module.exports = __webpack_public_path__ + "static/media/ding.8d2047ff.WAV";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/ding.WAV
// module id = 1533
// module chunks = 1